module.exports = function(angularModule) {
  angularModule.controller(
    'providerJobStatusSummaryController',
    function providerJobStatusSummaryController($scope, $log, $state, $stateParams, $location, providerJobStatusService) {

      $scope.jobTypes = providerJobStatusService.jobTypes;

      $scope.offset = Number($stateParams.offset) || 0;
      $scope.periodType = $stateParams.periodType || 'day';

      function goToDetail(provider) {
        $state.go('^.detail', Object.assign({}, $stateParams, {provider: provider}));
      }

      $scope.providerDetails = goToDetail;

      function setProviderMap(obj) {
        $scope.providers = Object.keys(obj).sort();
        $scope.currentProviderMap = {};
        $scope.providers.forEach(function (p) {
          $scope.currentProviderMap[p] = providerJobStatusService.buildColumnsFromUnorderedStatusItems(obj[p])
        });
      }


      $scope.onUpdateTimePeriod = function (periodType, offset) {
        $state.go('.', { periodType, offset })
      };

      $scope.loading = true;
      providerJobStatusService.getStatusForPeriod({ periodType: $scope.periodType, offset: $scope.offset }).then(function (resp) {
        $scope.loading = false;
        setProviderMap(resp.data.summary.byProvider);
      });

    });
}
